import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class BoundingBox extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.boundingbox',
        group: 'Spatial Constructors',
        title: 'ST Bounding Box',
        description: `
      This component creates a new column containing rectangles that represents the bounding box of each geometry.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return dedent`SELECT ST_GEOGFROMTEXT(CONCAT('POLYGON((', bbox.xmin, ' ', bbox.ymin, ', ', bbox.xmin, ' ', bbox.ymax, ', ',
                bbox.xmax, ' ', bbox.ymax, ', ', bbox.xmax, ' ', bbox.ymin, ', ',
                bbox.xmin, ' ', bbox.ymin, '))')) AS ${
                  params.geo
                }_bbox, * EXCEPT(bbox)
              FROM (
                SELECT ST_BOUNDINGBOX(${params.geo}) bbox, *
                FROM ${connection.quoteName(params.source as string)}
              )`
      case Provider.Snowflake:
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`
        SELECT ${connection.processOutputGeogColumn(
          `ST_ENVELOPE(${connection.processInputGeogColumn(
            params.geo as string
          )})`
        )} bbox, *
        FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`
        SELECT /*+ REPARTITION(40) */ ${connection.processOutputGeogColumn(
          `ST_ENVELOPE(${connection.processInputGeogColumn(
            params.geo as string
          )})`
        )} bbox, *
        FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_area`,
      type: ColumnDataType.Number
    })
  }
}

export { BoundingBox }
